export default {
  data() {
    return {
      hasFileLoading: false,
    };
  },
  methods: {
    onFileLoad(loading) {
      this.hasFileLoading = loading;
    },
    validateFile() {
      if (this.hasFileLoading) {
        this.$toast('Aguarde até o término do envio dos arquivos', { color: 'error' });
        return true;
      }
      return false;
    },
  },
};
